import { useInsightContext } from 'context';
import React from 'react';

import DataPresentation from './DataPresentation';
import Sidebar from './Sidebar';
import './QueryExplorer.scss';
import TopBar from './topBar/TopBar';

const QueryExplorer = (): React.ReactElement => {
  const { activeView } = useInsightContext();

  return (
    <div className='queryExplorer'>
      <div className='queryExplorer__topBar'>
        <TopBar />
      </div>
      <div className='queryExplorer__content'>
        {/* Temporary change: Sidebar is hidden for all views temporarily */}
        {!activeView ? <Sidebar /> : null}
        <DataPresentation />
      </div>
    </div>
  );
};

export default QueryExplorer;
